const genaiProjects = [
  {
    id: "ai-college-chatbot",
    title: "AI College Chatbot",
    category: "GenAI",
    domain: "Education",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: "₹2999",
    shortDescription:
      "An intelligent college chatbot that answers student queries using Generative AI and institutional knowledge.",
    description:
      "Build an AI-powered college assistant capable of answering questions about admissions, departments, courses, fees, timetable, notices and other college information.",
    technologies: [
      "Python",
      "LLM",
      "OpenAI API",
      "React",
      "Node.js",
      "MongoDB",
    ],
    skills: [
      "Prompt Engineering",
      "LLM Integration",
      "RAG",
      "API Integration",
      "Chatbot Development",
    ],
    features: [
      "AI conversational chatbot",
      "College knowledge base",
      "Context-aware responses",
      "Admin knowledge management",
      "Chat history",
      "Web-based interface",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE", "MSc CS"],
  },

  {
    id: "rag-document-chatbot",
    title: "AI Document Chatbot",
    category: "GenAI",
    domain: "Document Intelligence",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "Upload documents and interact with them using an AI-powered question-answering system.",
    description:
      "Develop a document intelligence platform where users can upload PDFs or text documents and ask questions using an LLM-powered RAG pipeline.",
    technologies: [
      "Python",
      "LLM",
      "RAG",
      "React",
      "Node.js",
      "Vector Database",
    ],
    skills: [
      "RAG",
      "Embeddings",
      "Vector Search",
      "Prompt Engineering",
      "LLM APIs",
    ],
    features: [
      "Document upload",
      "PDF processing",
      "Semantic search",
      "AI question answering",
      "Conversation history",
      "Source-aware responses",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },

  {
    id: "ai-resume-builder",
    title: "AI Resume Builder",
    category: "GenAI",
    domain: "Career Technology",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: "₹2999",
    shortDescription:
      "Generate professional resumes using AI based on candidate skills, education and experience.",
    description:
      "Create an AI-powered resume platform that collects candidate information and generates structured, professional resume content using Generative AI.",
    technologies: [
      "React",
      "Node.js",
      "MongoDB",
      "LLM API",
      "JavaScript",
      "PDF Generation",
    ],
    skills: [
      "Prompt Engineering",
      "AI Integration",
      "React Development",
      "API Development",
      "PDF Generation",
    ],
    features: [
      "AI-generated resume content",
      "Multiple resume sections",
      "Skill suggestions",
      "Professional templates",
      "PDF export",
      "Resume history",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },

  {
    id: "ai-interview-preparation",
    title: "AI Interview Preparation System",
    category: "GenAI",
    domain: "Career Technology",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "An AI-powered interview platform that generates questions and evaluates candidate responses.",
    description:
      "Build an intelligent interview preparation platform where AI generates role-specific questions and provides feedback on candidate answers.",
    technologies: [
      "React",
      "Node.js",
      "MongoDB",
      "LLM API",
      "Python",
      "Speech API",
    ],
    skills: [
      "Generative AI",
      "Prompt Engineering",
      "API Integration",
      "AI Evaluation",
      "Web Development",
    ],
    features: [
      "AI interview questions",
      "Role-based interviews",
      "Answer evaluation",
      "AI feedback",
      "Interview history",
      "Performance dashboard",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },

  {
    id: "ai-content-generator",
    title: "AI Content Generation Platform",
    category: "GenAI",
    domain: "Content Technology",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: "₹2999",
    shortDescription:
      "Generate blogs, social media posts, product descriptions and marketing content using AI.",
    description:
      "Develop a multi-purpose AI content platform that generates different types of professional content using configurable prompts and templates.",
    technologies: [
      "React",
      "Node.js",
      "MongoDB",
      "LLM API",
      "Bootstrap",
    ],
    skills: [
      "LLM Integration",
      "Prompt Engineering",
      "Frontend Development",
      "Backend Development",
      "API Design",
    ],
    features: [
      "Blog generation",
      "Social media content",
      "Product descriptions",
      "Content templates",
      "History management",
      "Copy/export content",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },

  {
    id: "ai-code-assistant",
    title: "AI Code Assistant",
    category: "GenAI",
    domain: "Developer Tools",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "An AI coding assistant that explains code, generates code and helps identify programming issues.",
    description:
      "Build an AI developer assistant capable of generating code snippets, explaining source code and providing suggestions for common programming problems.",
    technologies: [
      "React",
      "Node.js",
      "LLM API",
      "Python",
      "MongoDB",
    ],
    skills: [
      "LLM APIs",
      "Prompt Engineering",
      "Code Generation",
      "React",
      "API Development",
    ],
    features: [
      "Code generation",
      "Code explanation",
      "Bug assistance",
      "Multiple languages",
      "Chat interface",
      "Code history",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },

  {
    id: "ai-email-assistant",
    title: "AI Email Assistant",
    category: "GenAI",
    domain: "Productivity",
    difficulty: "Intermediate",
    duration: "5-7 Weeks",
    price: "₹2499",
    shortDescription:
      "Generate, summarize and improve professional emails using Generative AI.",
    description:
      "Create an AI productivity application that helps users draft emails, rewrite messages, summarize long content and adjust communication tone.",
    technologies: [
      "React",
      "Node.js",
      "LLM API",
      "MongoDB",
      "Bootstrap",
    ],
    skills: [
      "Prompt Engineering",
      "LLM Integration",
      "React",
      "REST APIs",
      "UI Development",
    ],
    features: [
      "Email generation",
      "Email rewriting",
      "Tone selection",
      "Email summarization",
      "History",
      "Copy to clipboard",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech"],
  },

  {
    id: "ai-study-assistant",
    title: "AI Study Assistant",
    category: "GenAI",
    domain: "Education",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3499",
    shortDescription:
      "An AI learning assistant that generates explanations, summaries, quizzes and study material.",
    description:
      "Develop an AI-powered educational assistant that helps students understand topics, generate summaries and practice through AI-generated questions.",
    technologies: [
      "React",
      "Node.js",
      "MongoDB",
      "LLM API",
      "Python",
    ],
    skills: [
      "Generative AI",
      "Prompt Engineering",
      "Educational AI",
      "API Integration",
      "React",
    ],
    features: [
      "AI explanations",
      "Topic summaries",
      "Question generation",
      "Quiz generation",
      "Study history",
      "Personalized learning",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },

  {
    id: "ai-meeting-summarizer",
    title: "AI Meeting Summarizer",
    category: "GenAI",
    domain: "Productivity",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "Convert meeting conversations into summaries, key points, decisions and action items.",
    description:
      "Build an AI meeting assistant that processes meeting transcripts and generates structured summaries, important decisions and follow-up tasks.",
    technologies: [
      "React",
      "Node.js",
      "Python",
      "LLM API",
      "Speech-to-Text",
      "MongoDB",
    ],
    skills: [
      "LLM Integration",
      "Speech Processing",
      "Text Summarization",
      "Prompt Engineering",
      "Full Stack Development",
    ],
    features: [
      "Transcript processing",
      "Automatic summaries",
      "Action item extraction",
      "Key decision extraction",
      "Meeting history",
      "Export summaries",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },

  {
    id: "ai-website-assistant",
    title: "AI Website Customer Assistant",
    category: "GenAI",
    domain: "Business Automation",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "An AI chatbot that can be integrated into business websites to answer customer questions.",
    description:
      "Develop a reusable AI customer-support assistant that learns from business information and provides automated responses through a website chat interface.",
    technologies: [
      "React",
      "Node.js",
      "MongoDB",
      "LLM API",
      "RAG",
      "REST API",
    ],
    skills: [
      "RAG",
      "Chatbot Development",
      "LLM Integration",
      "API Development",
      "React",
    ],
    features: [
      "Website chatbot",
      "Business knowledge base",
      "AI responses",
      "Conversation history",
      "Admin knowledge management",
      "Customer support automation",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
];

export default genaiProjects;